<template>
  <v-card dark class="edit institution">
    <v-card-title primary-title>
      <div>
        <div class="headline">{{ institution.name }}</div>
        <span class="grey--text">{{ institution.acronym }}</span>
      </div>
    </v-card-title>

    <v-alert color="error" transition="scale-transition" :value="institution.errors">
      <ul><li v-for="(message, i) in institution.errors" :key="`error-${i}`">{{ message }}</li></ul>
    </v-alert>

    <v-card-text>
      <v-form v-model="valid">
        <v-text-field
          label="Name"
          v-model="institution.name"
          :rules="rules.name" required
        />
        <v-text-field
          label="Acronym"
          v-model="institution.acronym"
          :rules="rules.acronym"
        />
        <v-select
          label="Default Grade Scale"
          v-model="institution.gradeScale"
          :items="gradeScales"
          :rules="rules.gradeScale"
        />
        <v-combobox multiple chips
          label="Former names"
          v-model="institution.formerNames"
          :items="[]"
          :rules="rules.gradeScale"
        ></v-combobox>
      </v-form>
    </v-card-text>

    <v-card-actions><v-spacer />
      <v-btn flat @click="$emit('cancel')" color="grey">
        Cancel
      </v-btn>
      <v-btn color="primary" @click="valid && $emit('update')">
        Update institution
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
// Data
import gradeScales from '@/data/grade_scales'

// Vue Component
export default {
  data() {
    return {
      // Data
      gradeScales,
      // Validation
      valid: true,
      rules: {
        name: [v => !!v || 'must be specified'],
        acronym: [],
        gradeScale: [],
        formerNames: [],
      },
    }
  },
  computed: {
    institution() { return this.$store.getters['admin/institutions/find'](this.$route.params.id) }
  },
}
</script>
